export default __webpack_public_path__ + "static/media/landing-slider-image-3.90a9397d.png";